<template lang="pug">
.content
  .row
    .col-md-12
      div.box_header
        label.title Quản lý giáo án
        .clearfix
      div.card.box-lesson-planning(v-if="lstPCs && lstPCs.length > 0")
        .box-header-group.first-header
          .item-content
          .item-number-count
            .item-group
              span Lý thuyết
            .item-group
              span Video
            .item-group
              span Bài tập
          .clearfix
        .box-info-pc(v-for="(item, index) in lstPCs")
          Item(:item="item" :key="increment")
</template>
<script>
import gql from 'graphql-tag'
import graphql from '../Model/graphql'
import MdNotification from '@/core/components/mdNotification'
import moment from 'moment'
import Item from '../Lesson_Planning/item'
export default {
  components: {
    Item,
    MdNotification
  },
  data() {
    return {
      message: this.$t('home.comming_soon'),
      lstPCs: [],
      loader: null,
      increment: 0
    }
  },
  async mounted () {
    if (this.$route.params.reload === 1) {
      this.$router.go(0)
    }
    await this.autoRefresh()
  },
  methods: {
    showNotification(message, color, from, align, timeout) {
      this.$notifications.notify({
        type: color,
        icon: 'notifications',
        message: message,
        placement: {
          from,
          align
        },
        timeout: timeout
      })
    },
    show() {
      this.loader = this.$loading.show({
        color: '#ffffff',
        loader: 'spinner',
        width: 60,
        height: 60,
        backgroundColor: '#000000',
        opacity: 0.5,
        zIndex: 9999,
        container: null,
        canCancel: true,
        onCancel: this.onCancel
      })
    },
    formatDate(value) {
      return moment(value).format('DD/MM/YYYY - hh:mm')
    },
    async autoRefresh() {
      var variables = {
        where: {
          user_id: {_eq: this.$store.getters.user}
        },
        orderBy: {created_at: 'desc'}
      }
      const {data} = await this.$apollo.query({
        query: gql(graphql.GET_PC_OF_USER),
        fetchPolicy: 'no-cache',
        variables: variables
      }).catch((error) => {
        if (error.graphQLErrors[0].extensions.code === 'invalid-jwt') {
          this.$router.go(0)
        }
        console.error(error.message)
      })
      if (data && data !== null) {
        this.lstPCs = data.private_community
        // console.log(data.private_community)
      }
    }
  },
  watch: {
    '$route' (to, from) {
      if (to !== from) {
        this.autoRefresh()
      }
    }
  },
  apollo: {
  }
}
</script>

<style lang="scss">
  .box_header{
    label.title{text-align: left; font-size:20px;font-weight:bold;font-family: 'adobe-clean', sans-serif;letter-spacing: 0px;color: #5F6468;display:inline-block
    }
  }
  .box-lesson-planning{background: #fff; box-shadow: 0px 1px 3px #00000029; border-radius: 10px; overflow: hidden;
    .box-header-group{ padding: 15px; cursor: pointer;
      .item-content{width: calc(100% - 270px); display: inline-block;}
      .item-number-count{float: right;
        .item-group{width: 80px; display: inline-block; text-align: center;
          span{color: #343A40; font-size: 15px; font-weight: bold;}
          img{display: none;}
        }
      }
      &.box-row-pc{
        .item-content{
          .item-title{ display: flex;align-items: center;
            i{color: #343A40; font-size: 16px;display: inline-block;}
            span {margin-left: 11px; font-size: 15px; color: #333333; display: inline-block;}
          }
        }
        .item-group{cursor: pointer;
          span{color: #1A0DAB; font-size: 15px; font-weight: normal;text-decoration: underline;}
        }
        .item-body{display: none; padding-top: 15px;}
        &.open-expand{background: #F8F8F8 0% 0% no-repeat padding-box; box-shadow: 0px 1px 2px #00000029; padding-bottom: 0;
          .item-content{
            .item-title{
              span {font-size: 15px; color: #9F6A28; font-weight: bold;}
            }
          }
          .board-info{ padding: 15px 0;
            .item-title{
              span {font-size: 15px; color: #333; font-weight: normal;}
            }
          }
          .item-body{display: block; padding-left: 30px;
            .item-classes-planing-pc{ border-top: 1px solid #F3F3F3; padding-left: 15px;
              .item-content{
                .item-title{
                  span {margin-left: 0;}
                }
              }
            }
          }
        } 
      }
    }
  }
  .box-popup-confirm{box-shadow: 0px 3px 6px #00000029; border-radius: 10px !important;
  .dialog-content{ padding: 0;
    .dialog-c-title {text-transform: uppercase; text-align: left;font-size:17px; font-family: Helvetica;letter-spacing: 0px;color: #343A40; border-bottom: 1px solid #DFE2E6; padding: 12px 15px 15px; font-weight: bold; margin-bottom: 15px;}
    .dialog-c-text{padding: 0 15px;}
  }
  .vue-dialog-buttons {justify-content: center;display: flex; border: 0! important; margin-top: 30px; margin-bottom: 5px;
    .confirm-delete-dialog {background: #FFD311 0% 0% no-repeat padding-box! important;border-radius: 5px; width: 160px;color: #23180A! important;margin-right: 10px;flex: unset! important;}
    .cancel-delete-dialog, .cancel-delete-dialog:hover {background: #FFFFFF 0% 0% no-repeat padding-box! important;border: 1px solid #FFD311;border-radius: 5px;width: 160px;color: #23180A! important;flex: unset! important;}
  }
}
@media screen and (min-width: 768px){
  
}
@media screen and (max-width: 991px){
  .box-lesson-planning{
    .first-header{display: none;}
    .box-info-pc{
      .box-row-pc{
        .item-content{display: block; width: 100%;margin-bottom: 5px;}
        .item-body{padding-left: 0 !important;}
        .item-group{
          span{display: inline-block; margin-right: 5px;}
          img{width: 16px; height: 16px; display: inline-block;}
        }
      }
    }
  }
}
@media screen and (max-width: 768px){
  .box-lesson-planning{
    .first-header{display: none;}
  }
}
</style>



// WEBPACK FOOTER //
// index.vue?de4d979e